import PropTypes from "prop-types";
// import Mui components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

// redux
import { useDispatch } from "react-redux";
import {
    loadOverallRemovedKpiListState,
    loadAgreementRemovedKpiListState,
    loadClaimsRemovedKpiListState,
    loadJustRightRemovedKpiListState,
    loadSecondaryRemovedKpiListState,
    loadFragranceMetricsRemovedKpiListState,
    loadPreferenceRemovedKpiListState,
} from "../../../../store/features/analysisKpiSlice";

function RemoveRestoreButton({ backendVariableSettings, functionsSettings, analysisView }) {
    const dispatch = useDispatch();

    const { removedKpi, showCheckBox, disableRestore } = backendVariableSettings;
    const { setShowCheckBox, setOpenRestoreDialog } = functionsSettings;
    const { moduleName } = analysisView;
    const handleRemove = () => {
        if (showCheckBox) {
            if (removedKpi.length > 0) {
                // store removed kpis
                if (moduleName === "overall") {
                    dispatch(loadOverallRemovedKpiListState(removedKpi));
                } else if (moduleName === "secondary") {
                    dispatch(loadSecondaryRemovedKpiListState(removedKpi));
                } else if (moduleName === "agreement") {
                    dispatch(loadAgreementRemovedKpiListState(removedKpi));
                } else if (moduleName === "claims") {
                    dispatch(loadClaimsRemovedKpiListState(removedKpi));
                } else if (moduleName === "justRight") {
                    dispatch(loadJustRightRemovedKpiListState(removedKpi));
                } else if (moduleName === "fragranceMetrics") {
                    dispatch(loadFragranceMetricsRemovedKpiListState(removedKpi));
                } else if (moduleName === "preference") {
                    dispatch(loadPreferenceRemovedKpiListState(removedKpi));
                }
            }
            setShowCheckBox(false);
        } else {
            setShowCheckBox(true);
        }
    };

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 1,
            }}
        >
            <div style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>
                <Button
                    size="small"
                    className={"custom-btn liner-light-blue-background"}
                    variant="contained"
                    onClick={handleRemove}
                    style={{
                        fontSize: 12,
                    }}
                >
                    Remove Variables
                </Button>
                <Button
                    size="small"
                    className={disableRestore ? "custom-btn" : "custom-btn liner-light-blue-background"}
                    variant="contained"
                    onClick={() => setOpenRestoreDialog(true)}
                    disabled={disableRestore}
                    style={{
                        fontSize: 12,
                    }}
                >
                    Restore Variables
                </Button>
            </div>
            <p
                style={{
                    marginBottom: 0,
                    color: "#495057",
                    fontWeight: 600,
                    fontSize: 12,
                }}
            >
                {moduleName === "justRight" ? "5 point Middle-Box Likert scale" : ["claims", "agreement"].includes(moduleName) ? "Agreement Likert scale size is indicated in brackets () next to each variable" : `${moduleName !== "preference" ? "Likert scale size is indicated in brackets () next to each variable" : ""}`}
            </p>
        </Box>
    );
}

RemoveRestoreButton.propTypes = {
    backendVariableSettings: PropTypes.object,
    functionsSettings: PropTypes.object,
    analysisView: PropTypes.object,
};
export default RemoveRestoreButton;
